// Masonry feed layout: column count per breakpoint and the gap between cards.

export const columnsCountBreakPoints = {
  0: 2, // Phones (Instagram/Reddit-style 2-col grid; tap a tile → fullscreen feed)
  768: 3, // Tablets
  1024: 4, // Small laptops
  1440: 5, // Large laptops / desktops
}

export const gutter = '0.5rem'
